import { connect } from 'react-redux'
import LandingPage from '../components/landing-page'

const mapStateToProps = state => ({...state.landingPage})

export default connect(mapStateToProps)(LandingPage)
